<div>
    <mat-dialog-content>
        <div class="header">
            <div class="rate-txt">Approve Prompt {{is_chain?' Chain':''}}</div>
            <div>
                <img src="/assets/icons/Close.svg" (click)="onConfirmClick()" alt="close"/>
            </div>
        </div>

        @if(is_version){
        <div class="approving">
            By approving this prompt, Version {{current_version}} will be published and made available to the 
            end user, while the previous version will be automatically archived.
        </div>   
        }@else if(is_variant){
            <div class="approving">
                By approving this prompt, variant {{current_variant}} will be
                published and accessible to the end user.
            </div>   
        }
        
        @else{
        <div class="approving">
            Approving this prompt {{is_chain?' Chain':''}} will result in its publication and availability to end users for their consumption.
        </div>
        }
        <div class="approving">
            Are you sure, you want to proceed with publishing it?
        </div>    
        
        <div class="btn-div">
            <button class="plain-btn" (click)="onConfirmClick()">Cancel</button>
            <button class="primary-btn" (click)="onPublish()">Publish</button>
        </div>
    </mat-dialog-content>
</div>